<template>
  <div class="Indicators d-flex align-center">
    <v-col
      v-if="risk"
      class="indicator-col col-4"
    >
      <div class="indicator">
        {{ $t('crm.userList.risk-level') }}
      </div>
      <div
        class="indicator--risk white--text"
        :class="[`risk-bg-color-${risk}`]"
      >
        {{ $t(`main.enums.risk.${risk}`) }} -
        {{ risk }}
      </div>
    </v-col>
    <v-divider
      class="divider"
      vertical
      inset
    />
    <v-col
      v-if="!isNaN(revivals)"
      class="indicator-col col-4"
    >
      <div class="indicator">
        {{ $t('crm.userList.raises-number') }}
      </div>
      <div class="indicator--revivals">{{ revivals }}</div>
    </v-col>
    <v-divider
      class="divider"
      vertical
      inset
    />
    <v-col
      v-if="status"
      class="indicator-col col-4"
    >
      <div class="indicator">
        {{ $t('crm.userList.profile-status') }}
      </div>
      <div
        class="indicator--status"
        :class="[`status-color-${status}`]"
      >
        {{ $t(`main.enums.status.${status}`) }}
      </div>
    </v-col>
  </div>
</template>

<script>
  export default {
    props: {
      risk: {
        type: Number,
        required: true,
      },
      revivals: {
        type: Number,
        required: true,
      },
      status: {
        type: String,
        required: true,
      },
    },
  }
</script>

<style lang="scss" scoped>
.Indicators {
  width: 100%;
  .indicator-col {
    padding: 0 0.5rem;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    .indicator {
      font-size: 0.8rem;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 20px;
      text-align: right;
      color: $color-4d4d4f;
      text-transform: uppercase;

      &--risk {
        font-size: 0.7rem;
        padding: 2px 8px;
        // background-color: $color-00d367;
        border-radius: 4px;
        text-transform: uppercase;
      }
      &--revivals {
        font-size: 0.9rem;
        color: $color-001c4b;
      }
      &--status {
        font-size: 0.9rem;
      }
    }
  }
  .divider {
    margin-left: 0.5rem;
    height: 41px;
    border-radius: 0.5px;
    width: 2px;
    border: 1px solid rgba(158, 159, 162, 0.16);
    box-sizing: border-box;
  }
}
.status-color-created {
  color: $color-00d367;
}
.status-color-pending {
  color: $color-00d367;
}
.status-color-validated_by_user {
  color: $color-00d367;
}
.status-color-validated_by_advisor {
  color: $color-004f9f;
}
.status-color-abandoned {
  color: $color-c6201d;
}
.risk-bg-color-1,
.risk-bg-color-2 {
  background-color: $color-009ee0;
}
.risk-bg-color-3 {
  background-color: $color-f07d00;
}
.risk-bg-color-4 {
  background-color: $color-ff524f;
}
</style>
